module.exports = __webpack_public_path__ + "media/country_flags/do-7c8b614d.png";